import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "student" });
  const [loading, setLoading] = useState(false);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form);
      toast.success("Welcome to Knacky!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="nb-card p-8">
        <h1 className="text-4xl font-extrabold">Create your account</h1>
        <p className="text-neutral-600 mt-1">Start learning smarter in 30 seconds.</p>

        <button data-testid="signup-google" onClick={handleGoogle} className="w-full mt-6 nb-btn nb-btn-secondary">
          <img src="https://www.gstatic.com/marketing-cms/assets/images/d5/dc/cfe9ce8b4425b410b49b7f2dd3f3/g.webp" alt="G" className="w-4 h-4" />
          Continue with Google
        </button>
        <div className="my-4 flex items-center gap-2 text-xs text-neutral-500"><div className="flex-1 h-px bg-black" />OR<div className="flex-1 h-px bg-black" /></div>

        <form onSubmit={submit} className="space-y-3">
          <input data-testid="signup-name" className="nb-input" placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
          <input data-testid="signup-email" className="nb-input" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          <input data-testid="signup-password" className="nb-input" type="password" placeholder="Password (min 6 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} />
          <select data-testid="signup-role" className="nb-input" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
            <option value="student">Student</option>
            <option value="teacher">Teacher</option>
            <option value="school_admin">School Admin</option>
          </select>
          <button data-testid="signup-submit" type="submit" disabled={loading} className="w-full nb-btn">
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="text-sm text-center mt-4">Already have an account? <Link data-testid="signup-login-link" to="/login" className="font-bold underline">Log in</Link></p>
      </div>
    </div>
  );
}
